import { Chip } from "designSystem/index";
import React, { FunctionComponent } from "react";

interface ProofingStageNumberChipProps {
	stageIndex: number;
}

export const ProofingStageNumberChip: FunctionComponent<ProofingStageNumberChipProps> = ({ stageIndex }) => {
	return (
		<Chip
			res="StageNumber"
			resParams={[stageIndex]}
			sx={{
				borderRadius: 1,
			}}
		/>
	);
};